// The external supervisor's dashboard: every weekly timesheet addressed to their
// email, behind an emailed code. No TradiePass account, so each leaf is `public`
// (the router guard reads the leaf's own meta and skips login, MFA and onboarding).
export default {
  path: '/external-supervisor',
  component: { render: (h) => h('router-view') },
  meta: { public: true },
  children: [
    {
      path: '',
      name: 'external-supervisor',
      meta: { public: true },
      component: () =>
        import(
          /* webpackChunkName: "external-supervisor" */ '@/views/externalApproval/ExternalSupervisorDashboard.vue'
        ),
    },
    {
      // One sheet opened from the list: the approval page in dashboard mode.
      path: ':requestId(\\d+)',
      name: 'external-supervisor-sheet',
      meta: { public: true },
      props: (route) => ({ dashboardId: route.params.requestId }),
      component: () =>
        import(
          /* webpackChunkName: "external-approval" */ '@/views/externalApproval/ExternalApprovalPage.vue'
        ),
    },
  ],
}
